import React from 'react'
import hooks from '../../../hooks'

const useRefreshDiscussions = ({
    discussionId,
    onRefreshed = () => {}
}) => {
    const { id } = hooks.useCurrentUser()
    const cacheKeys = hooks.useCacheKeys()
    const { clearCache } = hooks.useCache({ key: [ cacheKeys.DISCUSSIONS, id ], onReload: onRefreshed})

    React.useEffect(() => {
        if (discussionId) {
            const timeout = setTimeout(clearCache, 600)
            return () => clearTimeout(timeout)
        }
    }, [discussionId])

    return {
        refreshDiscussions: clearCache
    }
}

export default useRefreshDiscussions
